export interface Pais {
  codigo: string;
  nombre: string;
  codigo_telefonico: string;
  bandera: string;
}

export function createEmptyPais(): Pais {
  return {
    codigo: null,
    nombre: null,
    codigo_telefonico: null,
    bandera: null
  };
}
